import React from "react";
import "../../Styles/certified/grootan.css";

export default function Grootan() {
  return (
    <>
      <div className="grootan-certified-details-section">
        <div className="grootan-certified-details-title">
          OUTSTANDING WORKPLACES CERTIFIED COMPANIES
        </div>
        <div className="grootan-certified-details-container">
          {/* Left: Badge and Company Info side by side */}
          <div className="grootan-certified-details-left">
            <img
              src="/Dec2025Dec2026.png"
              alt="Outstanding Workplaces Certified"
              className="grootan-certified-badge"
            />
            <div className="grootan-certified-company-names">
              <a href="https://www.grootan.com" target="_blank" rel="noopener noreferrer">
                <img src="/assets/grootan/grootan2.png" alt="Grootan Logo" className="grootan-certified-company-logo" />
              </a>
              <h1 className="grootan-certified-full-name">
                Grootan Technologies Private Limited
              </h1>
            </div>
          </div>
          {/* Right: Company Image */}
          <div className="grootan-certified-details-right">
            <img
              src="/assets/grootan/Grootan1.jpg"
              alt="Grootan Office"
              className="grootan-certified-company-image"
            />
          </div>
        </div>
        {/* Description section below */}
        <div className="grootan-certified-description">
          <h2>
            Why Grootan Technologies Private Limited is a Outstanding Workplaces
          </h2>
          <p>
            Grootan Technologies is a global technology company delivering secure, scalable, and customized digital solutions across industries.
            As a pioneer in Identity-as-a-Service (IDaaS), Grootan supports clients in financial services, insurance, retail, healthcare, and gaming with end-to-end technology services including consulting, digital engineering, system design, CI/CD, deployment, and managed services.<br/><br/>
            The organisation is ISO 27001:2022 certified and is known for its strong emphasis on information security, customer-centricity, and innovation.
            With its headquarters in Chennai, Grootan has built a workplace culture rooted in simplicity, creativity, agility, and human-centric leadership.
          </p>
        </div>
        {/* Info Cards Section */}
        <div className="grootan-certified-info-cards">
          <div className="grootan-certified-info-card">
            <div className="grootan-certified-info-title">COMPANY SIZE</div>
            <div className="grootan-certified-info-value">82 Employees</div>
          </div>
          <div className="grootan-certified-info-card">
            <div className="grootan-certified-info-title">INDUSTRY</div>
            <div className="grootan-certified-info-value">Information Technology &<br /> IT Services</div>
          </div>
          <div className="grootan-certified-info-card">
            <div className="grootan-certified-info-title">CONNECT</div>
            <div className="grootan-certified-info-icons">
              <span className="grootan-certified-icon-round">
                <a href="https://www.grootan.com" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/website.png" alt="Website" />
                </a>
              </span>
              <span className="grootan-certified-icon-round">
                <a href="https://in.linkedin.com/company/grootan-technologies" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/linkedin.png" alt="LinkedIn" />
                </a>
              </span>
              <span className="grootan-certified-icon-round">
                <a href="https://www.facebook.com/grootantech" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/facebook.png" alt="Facebook" />
                </a>
              </span>
            </div>
          </div>
          <div className="grootan-certified-info-card">
            <div className="grootan-certified-info-title">LOCATION (HQ)</div>
            <div className="grootan-certified-info-value">Chennai</div>
          </div>
        </div>
        {/* Recognitions Section */}
        <div className="grootan-certified-recognition-section">
          <h2 className="grootan-certified-recognition-title">
            Recognitions awarded by Outstanding Workplaces
          </h2>
          <div className="grootan-certified-recognition-badge">
            <img
              src="/Dec2025Dec2026.png"
              alt="Outstanding Workplaces Certified"
              className="grootan-certified-recognition-image"
            />
          </div>
          <div className="grootan-certified-recognition-label">
            Outstanding Workplaces - Platinum Certified
          </div>
        </div>
        {/* Life at Grootan Section */}
        <div className="grootan-certified-life-section">
          <h2 className="grootan-certified-life-title">
            Life at Grootan Technologies Private Limited
          </h2>
          <div className="grootan-certified-life-gallery">
            <div className="grootan-certified-life-col">
              <img src="/assets/grootan/Grootan5.jpg" alt="Office 1" className="grootan-certified-life-img" />
              <img src="/assets/grootan/Grootan3.jpg" alt="Meeting 1" className="grootan-certified-life-img" />
            </div>
            <div className="grootan-certified-life-col grootan-certified-life-center">
              <img src="/assets/grootan/Grootan4.jpg" alt="Main Office" className="grootan-certified-life-img grootan-certified-life-img-large" />
            </div>
            <div className="grootan-certified-life-col">
              <img src="/assets/grootan/Grootan1.jpg" alt="Office 2" className="grootan-certified-life-img" />
              <img src="/assets/grootan/Grootan2.jpg" alt="Meeting 2" className="grootan-certified-life-img" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}